const blurb = (
    <p>
      I am a PhD student at Northeastern University, Boston, working in the NDS2 Lab advised by <strong>Professor Cristina Nita-Rotaru</strong>. 
      My current work focuses on security in LLM-based Agentic AI systems, with a special focus on Multi-Agent Systems. My work is supported by the <strong>NSF Graduate Research Fellowship</strong>. Previously I graduated from Williams College with Highest Honors in Computer Science. 
      There, I published a paper in the field of experimental Algorithms along side <strong>Professor Sam McCauley</strong>, and for my undergradute thesis I worked on causal inference with protein sequences advised by <strong>Professor Rohit Bhattacharya</strong>.
    </p>
  );
  
  export default blurb;
  